<template>
    <p-search-screen
        title="Courses"
        api-destination="courses"
        :filters="filters"
        :filterBy="filterBy"
        :fields="fields"
        edit-key="courseId"
        add-new-button
    >
        <template v-slot:afterSearch>
            <b-col cols="3">
                <p-select
                    class=" style ms-2 "
                    no-selection-message="All Campuses"
                    dataType="campuses"
                    v-model="filters.campusId"
                />
            </b-col>
        </template>
    </p-search-screen>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'CoursesFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'name',
                sortDesc: true,
                searchBy: 'All'
            },
            filterBy: ['All', 'Name', 'Description', 'Department'],
            fields: [
                {
                    key: 'name',
                    sortable: true
                },
                {
                    key: 'description',
                    sortable: true
                },

                {
                    key: 'department',
                    sortable: true
                },
                {
                    key: 'campus',
                    sortable: true
                }
            ]
        };
    }
};
</script>

<style scoped lang="scss">

:deep(.custom-select ) {
    height: 43px;
}
</style>
